module.exports = __webpack_public_path__ + "img/step29_a_stand_power_slot_blockers.f7f61d26.png";